import create from 'zustand'

interface FooterState {
  footerContent: JSX.Element | null
}

interface FooterActions {
  setFooterContent: (content: JSX.Element | null) => void
}

type FooterStore = FooterState & FooterActions

const useFooterStore = create<FooterStore>(set => ({
  footerContent: null,
  setFooterContent: content => set({ footerContent: content }),
}))

export default useFooterStore
